import { useEffect, useState } from 'react';
import Lottie from 'react-lottie';
import rocketBlue from '@graphic/rocketBlue.json';
import rocketGreen from '@graphic/rocketGreen.json';
import { useDchampsInfo, useDhampsFinalsCheck } from '@repository/dchamps/useDchamps';
import { useUserInfo } from '@repository/auth/useUserInfo';
import DevChampsInfoListVO from '@domain/vo/dchamps/DevChampsInfoListVO';
import { DchampsEventType } from '@domain/constant/dchamps/eventType';
import classnames from 'classnames/bind';
import styles from './countHeader.module.scss';
import DateUtil from '@utils/date/util';
import DateFormat from '@utils/date/format';

const cx = classnames.bind(styles);

const visualOptions_qualify = {
  loop: true,
  autoplay: false,
  animationData: rocketGreen,
};

const visualOptions_finals = {
  loop: true,
  autoplay: false,
  animationData: rocketBlue,
};

const DChampsCountHeader = () => {
  const { data: userData } = useUserInfo();
  const isLogin = !!userData?.id;
  const { data: dchampsInfo, refetch } = useDchampsInfo();
  const eventType = dchampsInfo?.progressFinal?.eventType;
  const { data: isFinalist } = useDhampsFinalsCheck(isLogin && !!eventType, eventType as DchampsEventType);
  //본선진출자이고 다음 예선이 현재 본선과 다른경우 본선 카운트다운을 보여줌.
  const dchampsData =
    isLogin && isFinalist && dchampsInfo?.progressQualify?.eventType !== dchampsInfo?.progressFinal?.eventType
      ? dchampsInfo?.progressFinal
      : dchampsInfo?.progressQualify;
  const countDateInfo = DevChampsInfoListVO.getCountInfo(dchampsData, dchampsData?.dchampsStatusType);
  const inQualify = dchampsData?.dchampsStatusType === 'IN_QUALIFY';

  const [timeValue, setTimeValue] = useState('');

  useEffect(() => {
    if (!dchampsInfo || !countDateInfo) return;

    const interval = setInterval(() => {
      const current = DateUtil.getNow();
      const countDate = countDateInfo.countDate;
      if (DateUtil.isPastDate(countDate)) {
        refetch();
        return;
      }

      setTimeValue(DateFormat.formatDateDiff(current, countDate, 'dd일 HH시간 mm분 ss초'));
    }, 1000);

    return () => clearInterval(interval);
  }, [dchampsInfo, dchampsData]);

  if (!dchampsInfo) return null;

  return (
    <div className={cx('dChamsCountHeader', { inQualify })}>
      <div className={cx('lottieWrap')}>
        <Lottie options={inQualify ? visualOptions_qualify : visualOptions_finals} />
      </div>
      <span className={cx('text', { inQualify })}>{countDateInfo?.headerText}</span>
      <span className={cx('date', { inQualify })}>{timeValue}</span>
    </div>
  );
};

export default DChampsCountHeader;
